<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.bairro"
        ref="DataTable"
        :disabled-button-search="true"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-bairro-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-cadastro-bairro"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-cadastro-bairro"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    created() {

        this.repositories.bairro = this.getConectaSusRepository('cadastro.localizacao.bairro')
    },
    data: () => ({
        fields: [
            {
                name: 'nome',
                key: 'nome',
                label: 'Nome',
                searchable: true,
                sortable: true
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        repositories: {
            bairro: null,
        },
    }),
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.bairro.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o bairro?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>